import React, { useEffect, useMemo, useRef, useState } from "react";
import Cookies from "js-cookie";
import smartLendLogo from "./img/sl_long_new_logo_wo_beta.png";
import singpassLogo from "./img/singpass_logo.png";
import bankImage from "./img/11.png";
import bankImage1 from "./img/12.png";
import bankImage2 from "./img/13.png";
import bankImage3 from "./img/14.png";
import bankImage4 from "./img/15.png";
import bankImage5 from "./img/16.png";
import bankImage6 from "./img/17.png";
import bankImage7 from "./img/18.png";
import bankImage8 from "./img/19.png";
import enim1 from "../../../assets/enabled_by/1.png";
import enim2 from "../../../assets/enabled_by/2.png";
import enim3 from "../../../assets/enabled_by/3.png";
import chocoUpLogo from "./img/chocouplogo.png";
import FaqSection from "../../../borrower/loan/Loan-hub-faq";
import { useHistory } from "react-router-dom";

const IconBadge = ({ icon, label }) => (
  <span className="sl-badge">
    <span className="sl-badgeIcon">{icon}</span>
    <span>{label}</span>
  </span>
);

const SectionHeader = ({ kicker, title, desc, align = "left", right }) => (
  <div className={`sl-sectionHeader sl-align-${align}`}>
    <div>
      {kicker ? <div className="sl-kicker">{kicker}</div> : null}
      <h2 className="sl-sectionTitle">{title}</h2>
      {desc ? <p className="sl-sectionDesc">{desc}</p> : null}
    </div>
    {right ? <div className="sl-sectionRight">{right}</div> : null}
  </div>
);

const FeatureCard = ({ icon, title, desc, meta }) => (
  <article className="sl-featureCard">
    <div className="sl-featureTop">
      <div className="sl-featureIcon">{icon}</div>
      {meta ? <div className="sl-featureMeta">{meta}</div> : null}
    </div>
    <h3 className="sl-featureTitle">{title}</h3>
    <p className="sl-featureDesc">{desc}</p>
  </article>
);

const MarqueeLogos = ({ logos }) => {
  const loop = [...logos, ...logos];
  return (
    <div className="sl-marqueeWrap">
      <div className="sl-marqueeFade sl-left" />
      <div className="sl-marqueeFade sl-right" />
      <div
        className="sl-marqueeTrack"
        aria-label="Featured logos scrolling list"
      >
        {loop.map((logo, idx) => (
          <div className="sl-marqueeItem" key={`${idx}-${logo}`}>
            <img src={logo} alt={`Featured logo ${idx + 1}`} />
          </div>
        ))}
      </div>
    </div>
  );
};

const formatCurrency = (value) => {
  return new Intl.NumberFormat("en-SG", {
    style: "currency",
    currency: "SGD",
    maximumFractionDigits: 0,
  }).format(Number(value) || 0);
};

const LANDING_PAGE_LEAD_ENDPOINT =
  "https://www.smart-lend.com/api/landing-page-leads/upsert";
const LANDING_PAGE_PATH = "/corporate-campaign";
const LANDING_PAGE_VISITOR_COOKIE = "landing_page_visitor_token";
const LANDING_PAGE_SOURCE_COOKIE = "landing_page_source";

const PARTNERSHIP_CHOCOUP = "chocoup";

const createVisitorToken = () => {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `lpl-${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

// ===== Screenshot Sections =====

const StatStrip = ({ items }) => {
  return (
    <section
      className="sl-fade"
      style={{
        marginTop: 18,
        borderRadius: 18,
        overflow: "hidden",
        border: "1px solid rgba(255,255,255,0.10)",
        boxShadow: "0 20px 60px rgba(2,6,23,0.25)",
      }}
    >
      <div
        style={{
          background:
            "radial-gradient(800px 240px at 10% 10%, rgba(109,92,246,0.35), transparent 60%), radial-gradient(700px 240px at 90% 20%, rgba(37,99,235,0.30), transparent 60%), linear-gradient(180deg, #0b1220, #0f172a)",
          padding: "18px 18px",
        }}
      >
        <div className="sl-statGrid">
          {items.map((it) => (
            <div key={it.label} className="sl-statItem">
              <div className="sl-statValue">{it.value}</div>
              <div className="sl-statLabel">{it.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const ComparisonTable = ({ rows }) => {
  return (
    <div className="sl-compareWrap">
      <div className="sl-compareHeader">
        <div className="sl-compareCell sl-compareHeadLeft">What you get</div>
        <div className="sl-compareCell sl-compareHeadMid">Loan Broker</div>
        <div className="sl-compareCell sl-compareHeadRight">SmartLend ✦</div>
      </div>

      {rows.map((r) => (
        <div className="sl-compareRow" key={r.item}>
          <div className="sl-compareCell sl-compareLeft">{r.item}</div>
          <div className="sl-compareCell sl-compareMid">
            <span className={`sl-compareTag ${r.brokerTone || ""}`}>
              {r.broker}
            </span>
          </div>
          <div className="sl-compareCell sl-compareRight">
            <span className={`sl-compareTag ${r.smartTone || ""}`}>
              {r.smart}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

const EDGE_FEATURES = [
  {
    icon: "🏦",
    title: "Singapore's Widest P2P Network",
    desc: "20+ licensed P2P corporate lenders on one platform. More options means more competition — and better rates for you.",
  },
  {
    icon: "🚫",
    title: "Zero Fees for Borrowers",
    desc: "We earn a referral from lenders, not you. This doesn't affect the rate you receive — lenders price their offers based on your profile, not our fee.",
  },
  {
    icon: "⚡",
    title: "Exclusive Rate Campaigns",
    desc: "Our volume gives us leverage. We regularly negotiate reduced interest rates and processing fees exclusively for SmartLend borrowers.",
  },
  {
    icon: "🔒",
    title: "Singpass-Powered, Secure",
    desc: "Singpass integration auto-fills your details securely. No sensitive data stored on our servers. MAS-compliant lenders only.",
  },
  {
    icon: "📊",
    title: "No CBS Hard Enquiry",
    desc: "The CBS report is retrieved by you using your own access code. Our lenders are not banks, so it shows as a self-enquiry — protecting your score.",
  },
  {
    icon: "🤝",
    title: "Concierge Service Available",
    desc: "Want a dedicated Relationship Manager? Upgrade to SmartLend Concierge for one-on-one support, pre-approval checks, and direct lender negotiations.",
  },
];

const WHY_ROWS = [
  {
    item: "Broker / referral fees",
    broker: "3%–30% of loan",
    brokerTone: "danger",
    smart: "✓ Zero",
    smartTone: "good",
  },
  {
    item: "Full lender network access",
    broker: "⚠ Selective",
    brokerTone: "warn",
    smart: "✓ All 20+ lenders",
    smartTone: "good",
  },
  {
    item: "Transparent competing offers",
    broker: "✗ You see one offer",
    brokerTone: "danger",
    smart: "✓ Compare all offers",
    smartTone: "good",
  },
  {
    item: "Exclusive rate campaigns",
    broker: "✗ Not available",
    brokerTone: "danger",
    smart: "✓ Volume discounts",
    smartTone: "good",
  },
  {
    item: "Application time",
    broker: "Days of back-and-forth",
    brokerTone: "warn",
    smart: "✓ < 3 mins via Singpass",
    smartTone: "good",
  },
  {
    item: "CBS enquiry impact",
    broker: "⚠ Hard enquiry risk",
    brokerTone: "warn",
    smart: "✓ Self-enquiry only",
    smartTone: "good",
  },
];

const STAT_ITEMS = [
  { value: "20+", label: "Licensed P2P lenders" },
  { value: "94%", label: "Average approval rate" },
  { value: "$0", label: "Broker or platform fees" },
  { value: "24–48h", label: "To receive competing offers" },
];

const QUALIFY_CARDS = [
  {
    icon: "🏢",
    title: "Private Limited Company",
    desc: "Must be a Singapore-registered Pte. Ltd. company. Sole proprietorships and partnerships are not eligible.",
    meta: "✓ Pte. Ltd. only",
  },
  {
    icon: "📅",
    title: "Minimum 6 Months Operating",
    desc: "Your company must have been actively operating for at least 6 months from date of incorporation.",
    meta: "✓ Min. 6 months in operation",
  },
  {
    icon: "🇸🇬",
    title: "Singapore-Registered Entity",
    desc: "Company must be registered and based in Singapore. Directors must be Singpass-eligible.",
    meta: "✓ Singapore registration",
  },
];

// ChocoUp partnership: benefits grid (from screenshot)
const CHOCOUP_TOP_STATS = [
  { value: "24hr", label: "Guaranteed response for all campaign applicants" },
  { value: "$0", label: "Platform fee, broker fee & concierge — all included" },
  { value: "S$500K+", label: "Max quick loan available through this campaign" },
  { value: "0%", label: "Equity required — non-dilutive financing" },
];

const CHOCOUP_BENEFIT_TILES = [
  {
    icon: "📉",
    kicker: "EXCLUSIVE",
    title: "Preferential interest rates",
    desc: "Campaign-only rates negotiated between SmartLend and Choco Up.",
    tone: "tint",
  },
  {
    icon: "📅",
    kicker: "FLEXIBLE",
    title: "Extended repayment tenor",
    desc: "Longer periods tailored to your cash flow cycle.",
  },
  // {
  //   icon: "🚫",
  //   kicker: "ZERO COST",
  //   title: "No broker fee, ever",
  //   desc: "No brokers, no middlemen, no hidden charges. Apply direct.",
  // },
  // {
  //   icon: "🧑‍💼",
  //   kicker: "GUIDED",
  //   title: "Dedicated concierge support",
  //   desc: "Your SmartLend concierge handles the whole journey at no cost.",
  // },
  // {
  //   icon: "🔎",
  //   kicker: "TRANSPARENT",
  //   title: "Zero equity, zero hidden fees",
  //   desc: "No equity dilution. No collateral. Simple, clear terms.",
  // },
  {
    icon: "🏦",
    kicker: "VERSATILE",
    title: "Multiple financing products",
    desc: "Uplift, Upstart, Upstart Plus & Upfront",
  },
  {
    icon: "🚀",
    kicker: "FAST",
    title: "Funds in days, not weeks",
    desc: "Most SMEs complete the full journey in under one week.",
  },
  // {
  //   icon: "⭐",
  //   kicker: "PLATFORM EXCLUSIVE",
  //   title: "Only on SmartLend",
  //   desc: "These terms are exclusively available through SmartLend — not available anywhere else.",
  //   tone: "tint",
  // },
];

// ChocoUp form: pre-qualification checklist (from screenshot)
const CHOCOUP_CHECKLIST = [
  {
    key: "sg_registered_1y",
    label:
      "Singapore-registered company with more than 1 year of incorporation",
  },
  {
    key: "min_1_local_director_pg",
    label: "Min. 1 local director willing to act as Personal Guarantor (PG)",
  },
  {
    key: "no_litigation_or_bankruptcy",
    label: "No active litigation or pending bankruptcy charges",
  },
  {
    key: "no_outstanding_mlcb",
    label: "No outstanding MLCB (Moneylenders Credit Bureau) owing",
  },
  {
    key: "cbs_above_hh",
    label: "CBS grade above HH (Credit Bureau Singapore)",
  },
  {
    key: "min_noa_20000",
    label: "Minimum NOA of $20,000 (Notice of Assessment)",
  },
  {
    key: "no_negative_bank_balance",
    label: "No negative bank balance on business account",
  },
  {
    key: "min_avg_eom_balance_10000",
    label: "Min. $10,000 average end-of-month bank balance",
  },
];

const CorporateCampaign = () => {
  const history = useHistory();
  const [loanAmount, setLoanAmount] = useState(50000);
  const [loanTerm, setLoanTerm] = useState(6);
  const [monthlyRate, setMonthlyRate] = useState(2.5);
  const [step, setStep] = useState(1);

  // Contact
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [consent, setConsent] = useState(false);
  const [touched, setTouched] = useState(false);
  const [contactSubmitted, setContactSubmitted] = useState(false);

  // Partnership param
  const partnership = useMemo(() => {
    if (typeof window === "undefined") return "";
    return (
      new URLSearchParams(window.location.search)
        .get("partnership")
        ?.trim()
        .toLowerCase() || ""
    );
  }, []);
  const isChocoUpPartnership = partnership === PARTNERSHIP_CHOCOUP;
  const effectiveMonthlyRate = isChocoUpPartnership ? 2 : monthlyRate;

  // ChocoUp extra form fields
  const [avgMonthlyRevenue, setAvgMonthlyRevenue] = useState("");
  const [businessOperating, setBusinessOperating] =
    useState("Less than 6 months");
  const [hasExistingFinancing, setHasExistingFinancing] = useState("No");
  const [checklistOpen, setChecklistOpen] = useState(true);
  const [prequal, setPrequal] = useState(() => {
    const init = {};
    CHOCOUP_CHECKLIST.forEach((i) => (init[i.key] = false));
    return init;
  });

  const checkedCount = useMemo(() => {
    return CHOCOUP_CHECKLIST.reduce(
      (acc, it) => acc + (prequal?.[it.key] ? 1 : 0),
      0,
    );
  }, [prequal]);

  const prequalFeedbackMessage = useMemo(() => {
    if (!isChocoUpPartnership || checkedCount === 0) return "";

    if (checkedCount === CHOCOUP_CHECKLIST.length) {
      return (
        <div style={{ fontSize: "11px", display: "flex", gap: "20px" }}>
          <div
            style={{
              fontSize: 27,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "rgba(0, 77, 42, 1)",
              color: "white",
              borderRadius: "80px",
              height: "40px",
              width: "40px",
            }}
          >
            ✓
          </div>
          <div style={{ width: "calc(100% - 100px)" }}>
            <strong style={{ fontSize: "16px" }}>
              Great news! You appear to meet the key criteria for this campaign.
            </strong>
            <br />
            Based on your selections, your profile is likely eligible for this
            financing program. Continue the application to proceed with the
            lender assessment.
          </div>
        </div>
      );
    }

    return (
      <div style={{ fontSize: "11px", display: "flex", gap: "20px" }}>
        <div
          style={{
            fontSize: 30,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "rgba(175, 79, 0, 1)",
            color: "white",
            borderRadius: "80px",
            height: "40px",
            width: "40px",
          }}
        >
          !
        </div>
        <div style={{ width: "calc(100% - 100px)" }}>
          <strong style={{ fontSize: "16px" }}>
            You may not fully meet the criteria for this specific campaign.
          </strong>
          <br />
          However, credit requirements vary across lenders. You may still be
          eligible for alternative financing options within our network.
          Continue your application to explore other available offers.
        </div>
      </div>
    );
  }, [isChocoUpPartnership, checkedCount]);

  // Visitor token
  const [visitorToken] = useState(() => {
    const existing = Cookies.get(LANDING_PAGE_VISITOR_COOKIE);
    if (existing) return existing;
    const generated = createVisitorToken();
    Cookies.set(LANDING_PAGE_VISITOR_COOKIE, generated, { expires: 365 });
    return generated;
  });

  const saveTimeoutRef = useRef(null);

  const monthlyRepayment = useMemo(() => {
    const monthlyRateDecimal = effectiveMonthlyRate / 100;
    const principalPerMonth = loanAmount / loanTerm;
    const interestPerMonth = loanAmount * monthlyRateDecimal;
    return principalPerMonth + interestPerMonth;
  }, [loanAmount, loanTerm, effectiveMonthlyRate]);

  const totalInterest = loanAmount * (effectiveMonthlyRate / 100) * loanTerm;
  const totalRepayment = loanAmount + totalInterest;

  const phoneIsValid = /^[0-9+\s-]{8,15}$/.test(phone.trim());
  const formIsValid = name.trim().length >= 2 && phoneIsValid && consent;

  const featuredLogos = [
    bankImage,
    bankImage1,
    bankImage2,
    bankImage3,
    bankImage4,
    bankImage5,
    bankImage6,
    bankImage7,
    bankImage8,
  ];

  const saveLeadSnapshot = async (overrides = {}) => {
    const baseLeadData = {
      loan_amount: loanAmount,
      loan_term: loanTerm,
      annual_rate: effectiveMonthlyRate * 12,
      monthly_rate: effectiveMonthlyRate,
      step,
      touched,
      contact_submitted: contactSubmitted,
      consent,
      source: LANDING_PAGE_PATH,
      partnership: partnership || "",
      // ChocoUp-only extras (safe to always include; backend can ignore when empty)
      chocoup_avg_monthly_revenue: isChocoUpPartnership
        ? avgMonthlyRevenue
        : "",
      chocoup_business_operating: isChocoUpPartnership ? businessOperating : "",
      chocoup_existing_financing: isChocoUpPartnership
        ? hasExistingFinancing
        : "",
      chocoup_prequal_checklist: isChocoUpPartnership ? prequal : {},
      chocoup_prequal_checked_count: isChocoUpPartnership ? checkedCount : 0,
      chocoup_prequal_total: isChocoUpPartnership
        ? CHOCOUP_CHECKLIST.length
        : 0,
    };

    const mergedLeadData = {
      ...baseLeadData,
      ...(overrides.lead_data || {}),
    };

    const payload = {
      visitor_token: visitorToken,
      landing_page_path: LANDING_PAGE_PATH,
      name,
      phone_number: phone,
      lead_data: mergedLeadData,
      ...overrides,
    };

    try {
      await fetch(LANDING_PAGE_LEAD_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
    } catch (error) {
      console.error("Failed to save landing page lead", error);
    }
  };

  useEffect(() => {
    Cookies.set(LANDING_PAGE_SOURCE_COOKIE, LANDING_PAGE_PATH, { expires: 30 });
    saveLeadSnapshot();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current);

    saveTimeoutRef.current = setTimeout(() => {
      saveLeadSnapshot();
    }, 1200);

    return () => {
      if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    loanAmount,
    loanTerm,
    monthlyRate,
    effectiveMonthlyRate,
    step,
    name,
    phone,
    consent,
    touched,
    contactSubmitted,
    partnership,
    avgMonthlyRevenue,
    businessOperating,
    hasExistingFinancing,
    prequal,
    checkedCount,
    isChocoUpPartnership,
  ]);

  const showEstimate = step === 1 || (step === 2 && contactSubmitted);
  const monthlyLabel = showEstimate
    ? formatCurrency(monthlyRepayment)
    : "Complete details to view";

  const styles = {
    page: {
      minHeight: "100vh",
      background:
        "radial-gradient(1200px 500px at 10% 0%, rgba(37, 99, 235, 0.20), transparent 55%), radial-gradient(900px 450px at 90% 10%, rgba(109, 92, 246, 0.18), transparent 55%), linear-gradient(180deg, #f7faff 0%, #ffffff 70%)",
      padding: "44px 18px",
    },
    container: { maxWidth: "80vw", margin: "0 auto" },
    topBar: {
      background:
        "linear-gradient(180deg, rgba(255,255,255,0.90), rgba(255,255,255,0.70))",
      border: "1px solid rgba(219, 230, 251, 0.9)",
      borderRadius: 18,
      padding: "14px 16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 14,
      position: "sticky",
      top: 12,
      zIndex: 20,
      backdropFilter: "blur(10px)",
      WebkitBackdropFilter: "blur(10px)",
      boxShadow: "0 10px 30px rgba(15, 23, 42, 0.06)",
    },

    brandLeft: {
      display: "flex",
      alignItems: "center",
      gap: 12,
      minWidth: 260,
    },

    hero: { marginTop: 18, marginBottom: 18 },
    heroTitle: {
      fontSize: 44,
      lineHeight: 1.08,
      margin: "0 0 12px",
      color: "#0b1220",
      letterSpacing: "-0.02em",
    },
    heroDesc: {
      margin: 0,
      color: "#475569",
      maxWidth: 780,
      fontSize: 16,
      lineHeight: 1.6,
    },

    layout: {
      display: "grid",
      gridTemplateColumns: "1.1fr 0.9fr",
      gap: 18,
      alignItems: "start",
    },

    card: {
      background:
        "linear-gradient(180deg, rgba(255,255,255,0.92), rgba(255,255,255,0.82))",
      borderRadius: 18,
      border: "1px solid rgba(219, 230, 251, 0.95)",
      padding: 20,
      boxShadow: "0 16px 40px rgba(15, 23, 42, 0.08)",
      backdropFilter: "blur(10px)",
      WebkitBackdropFilter: "blur(10px)",
      overflow: "hidden",
      position: "relative",
    },

    cardGlow: {
      position: "absolute",
      inset: "-120px -120px auto auto",
      width: 240,
      height: 240,
      borderRadius: 999,
      background:
        "radial-gradient(circle, rgba(37,99,235,0.20), transparent 60%)",
      pointerEvents: "none",
    },

    sectionTitle: { margin: "0 0 10px", color: "#0f172a", fontSize: 18 },
    muted: {
      color: "#64748b",
      fontSize: 13,
      margin: "0 0 12px",
      lineHeight: 1.5,
    },

    stepper: { display: "flex", gap: 8, marginBottom: 14, flexWrap: "wrap" },
    stepPill: (active) => ({
      borderRadius: 999,
      padding: "8px 10px",
      border: `1px solid ${
        active ? "rgba(37,99,235,0.45)" : "rgba(203,213,225,0.9)"
      }`,
      background: active ? "rgba(37,99,235,0.10)" : "rgba(255,255,255,0.85)",
      color: active ? "#1d4ed8" : "#334155",
      fontWeight: 800,
      fontSize: 12,
      display: "inline-flex",
      alignItems: "center",
      gap: 8,
    }),
    stepBubble: (active) => ({
      width: 18,
      height: 18,
      borderRadius: 999,
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: 11,
      fontWeight: 900,
      color: active ? "#ffffff" : "#0f172a",
      background: active ? "#2563eb" : "rgba(148,163,184,0.35)",
    }),

    fieldLabel: {
      display: "block",
      marginBottom: 8,
      fontWeight: 800,
      color: "#0f172a",
    },
    input: {
      width: "100%",
      padding: "12px 12px",
      borderRadius: 12,
      border: "1px solid rgba(203, 213, 225, 0.95)",
      background: "rgba(255,255,255,0.9)",
      outline: "none",
      fontSize: 14,
      color: "#0f172a",
    },
    select: {
      width: "100%",
      padding: "12px 12px",
      borderRadius: 12,
      border: "1px solid rgba(203, 213, 225, 0.95)",
      background: "rgba(255,255,255,0.9)",
      outline: "none",
      fontSize: 14,
      color: "#0f172a",
      appearance: "none",
    },

    rangeRow: {
      display: "flex",
      gap: 12,
      alignItems: "center",
      marginBottom: 10,
    },
    rangeValue: {
      minWidth: 140,
      textAlign: "right",
      fontWeight: 900,
      color: "#1d4ed8",
    },

    btnPrimary: (enabled = true) => ({
      width: "100%",
      padding: "12px 14px",
      border: "none",
      borderRadius: 12,
      background: enabled
        ? "linear-gradient(135deg, #2563eb 0%, #6d5cf6 100%)"
        : "rgba(147, 197, 253, 1)",
      color: "#ffffff",
      fontWeight: 900,
      cursor: enabled ? "pointer" : "not-allowed",
      boxShadow: enabled ? "0 14px 30px rgba(37,99,235,0.25)" : "none",
      transform: "translateY(0px)",
      transition:
        "transform 140ms ease, box-shadow 140ms ease, opacity 140ms ease",
    }),
    btnGhost: {
      width: "100%",
      padding: "12px 14px",
      borderRadius: 12,
      border: "1px solid rgba(148, 163, 184, 0.9)",
      background: "rgba(255,255,255,0.85)",
      fontWeight: 900,
      cursor: "pointer",
    },

    rightCard: {
      background: "linear-gradient(180deg, #0b1220, #0f172a)",
      color: "#ffffff",
      borderRadius: 18,
      padding: 20,
      border: "1px solid rgba(255,255,255,0.08)",
      position: "sticky",
      top: 92,
      boxShadow: "0 20px 60px rgba(2,6,23,0.35)",
      overflow: "hidden",
    },
    rightGlow: {
      position: "absolute",
      inset: "-160px auto auto -120px",
      width: 300,
      height: 300,
      borderRadius: 999,
      background:
        "radial-gradient(circle, rgba(109,92,246,0.35) 0%, rgba(37,99,235,0.18) 35%, transparent 68%)",
      pointerEvents: "none",
      filter: "blur(0px)",
    },
    estimateBox: {
      background: "rgba(148, 163, 184, 0.15)",
      border: "1px solid rgba(148, 163, 184, 0.18)",
      borderRadius: 14,
      padding: 16,
      marginBottom: 14,
    },
    estimateBig: {
      margin: 0,
      fontSize: 36,
      fontWeight: 950,
      letterSpacing: "-0.02em",
    },
    estimateSub: { margin: "0 0 8px", color: "#cbd5e1", fontSize: 13 },

    miniRow: { margin: "0 0 8px", color: "#cbd5e1", fontSize: 14 },
    disclaimer: {
      marginTop: 14,
      color: "#94a3b8",
      fontSize: 12,
      lineHeight: 1.5,
    },
  };

  const renderChocoUpHeroBanner = () => {
    if (!isChocoUpPartnership) return null;

    return (
      <section className="sl-chocoupHero sl-fade" style={{ marginTop: 18 }}>
        <div className="sl-chocoupHeroInner">
          <div>
            <h2 className="sl-chocoupHeroTitle">
              The smarter way to fund your SME —{" "}
              <span className="sl-chocoupHeroAccent">exclusively here.</span>
            </h2>
            <p className="sl-chocoupHeroDesc">
              Preferential rates, extended tenor, zero broker fees, and a
              dedicated concierge — only through SmartLend × Choco Up. Check
              eligibility in under 3 minutes.
            </p>
          </div>

          <div className="sl-chocoupHeroRight">
            <button
              type="button"
              className="sl-chocoupHeroBtn"
              onClick={() => {
                const el = document.getElementById("sl-form");
                if (el)
                  el.scrollIntoView({ behavior: "smooth", block: "start" });
              }}
            >
              Get Your Exclusive Offer →
            </button>
            <div className="sl-chocoupHeroNote">
              ⚡ Limited campaign slots — first-come, first-served
            </div>
          </div>
        </div>
      </section>
    );
  };

  const renderChocoUpBenefitsSection = () => {
    if (!isChocoUpPartnership) return null;

    return (
      <section className="sl-fade" style={{ marginTop: 18 }}>
        <div className="sl-sectionTint">
          <SectionHeader
            kicker="Benefits"
            title="Why SMEs choose SmartLend × Choco Up"
            desc="Guided, fast, and built around your business — not the bank's timeline."
            right={
              <>
                <IconBadge icon="⚡" label="Campaign-only terms" />
                <IconBadge icon="🧑‍💼" label="Concierge included" />
                <IconBadge icon="🚫" label="Zero broker fees" />
              </>
            }
          />

          {/* Top 4 stats */}
          <div className="sl-chocoupTopGrid">
            {CHOCOUP_TOP_STATS.map((s) => (
              <div className="sl-chocoupTopCard" key={s.value}>
                <div className="sl-chocoupTopValue">{s.value}</div>
                <div className="sl-chocoupTopLabel">{s.label}</div>
              </div>
            ))}
          </div>

          {/* Tiles (8) */}
          <div className="sl-chocoupTiles">
            {CHOCOUP_BENEFIT_TILES.map((t) => (
              <div
                key={t.title}
                className={`sl-chocoupTile ${t.tone === "tint" ? "tint" : ""}`}
              >
                <div className="sl-chocoupTileIcon">{t.icon}</div>
                <div className="sl-chocoupTileKicker">{t.kicker}</div>
                <div className="sl-chocoupTileTitle">{t.title}</div>
                <div className="sl-chocoupTileDesc">{t.desc}</div>
              </div>
            ))}
          </div>

          {/* Bottom bar */}
          <div className="sl-chocoupBottomBar">
            <div className="sl-chocoupBottomLeft">
              <span className="sl-chocoupBottomTag">★ PLATFORM EXCLUSIVE</span>
              <div className="sl-chocoupBottomText">
                <div className="sl-chocoupBottomTitle">
                  Exclusively available through SmartLend × Choco Up
                </div>
                <div className="sl-chocoupBottomDesc">
                  Preferential rates, extended tenor & concierge — only via this
                  co-branded campaign
                </div>
              </div>
            </div>

            <div className="sl-chocoupBottomRight">
              <div className="sl-chocoupPill">
                <span className="sl-chocoupPillDot" />
                SmartLend
              </div>
              <div className="sl-chocoupX">×</div>
              <div className="sl-chocoupPill ghost">
                <span className="sl-chocoupPillDot alt" />
                Choco Up
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  };

  return (
    <div style={styles.page}>
      <style>{`
        * { box-sizing: border-box; }

        .sl-range {
          -webkit-appearance: none;
          width: 100%;
          height: 8px;
          border-radius: 999px;
          background: linear-gradient(90deg, rgba(37,99,235,0.85), rgba(109,92,246,0.75));
          outline: none;
        }
        .sl-range::-webkit-slider-thumb {
          -webkit-appearance: none;
          width: 18px;
          height: 18px;
          border-radius: 999px;
          background: #ffffff;
          border: 2px solid rgba(37,99,235,0.9);
          box-shadow: 0 10px 20px rgba(2, 6, 23, 0.15);
          cursor: pointer;
        }
        .sl-range::-moz-range-thumb {
          width: 18px;
          height: 18px;
          border-radius: 999px;
          background: #ffffff;
          border: 2px solid rgba(37,99,235,0.9);
          box-shadow: 0 10px 20px rgba(2, 6, 23, 0.15);
          cursor: pointer;
        }

        .sl-fade { animation: slFade 220ms ease-out; }
        @keyframes slFade {
          from { opacity: 0; transform: translateY(6px); }
          to { opacity: 1; transform: translateY(0px); }
        }

        input:focus, select:focus {
          border-color: rgba(37,99,235,0.55) !important;
          box-shadow: 0 0 0 4px rgba(37,99,235,0.12) !important;
        }
        button:hover { transform: translateY(-1px); }
        button:active { transform: translateY(0px); }

        /* Section header */
        .sl-kicker{
          font-size:12px;
          font-weight:900;
          letter-spacing:.12em;
          text-transform:uppercase;
          color:#2563eb;
          margin-bottom:8px;
        }
        .sl-sectionTitle{
          margin:0;
          font-size:22px;
          letter-spacing:-.02em;
          color:#0f172a;
        }
        .sl-sectionDesc{
          margin:10px 0 0;
          color:#475569;
          line-height:1.7;
          max-width:780px;
        }
        .sl-sectionHeader{
          display:flex;
          align-items:flex-end;
          justify-content:space-between;
          gap:16px;
          margin-bottom:14px;
        }
        .sl-align-center{ text-align:center; justify-content:center; }
        .sl-align-center .sl-sectionDesc{ margin-left:auto; margin-right:auto; }
        .sl-sectionRight{ display:flex; gap:8px; flex-wrap:wrap; justify-content:flex-end; }

        /* Badges */
        .sl-badge{
          display:inline-flex;
          align-items:center;
          gap:8px;
          padding:8px 10px;
          border-radius:999px;
          background:rgba(255,255,255,0.75);
          border:1px solid rgba(203,213,225,0.9);
          box-shadow:0 10px 22px rgba(15,23,42,0.05);
          font-size:12px;
          font-weight:900;
          color:#0f172a;
        }
        .sl-badgeIcon{
          width:22px; height:22px;
          border-radius:10px;
          display:inline-flex;
          align-items:center;
          justify-content:center;
          background:linear-gradient(135deg, rgba(37,99,235,0.22), rgba(109,92,246,0.18));
          border:1px solid rgba(37,99,235,0.20);
        }

        /* Alternate section wrapper styles */
        .sl-sectionTint{
          background: linear-gradient(180deg, rgba(37,99,235,0.06), rgba(109,92,246,0.03));
          border: 1px solid rgba(219,230,251,0.95);
          border-radius: 18px;
          padding: 20px;
          box-shadow: 0 16px 40px rgba(15,23,42,0.06);
        }
        .sl-sectionDark{
          background: radial-gradient(800px 240px at 10% 10%, rgba(109,92,246,0.35), transparent 60%),
                      radial-gradient(700px 240px at 90% 20%, rgba(37,99,235,0.30), transparent 60%),
                      linear-gradient(180deg, #0b1220, #0f172a);
          border: 1px solid rgba(255,255,255,0.10);
          border-radius: 18px;
          padding: 20px;
          color: #ffffff;
          box-shadow: 0 20px 60px rgba(2,6,23,0.35);
        }
        .sl-sectionDark .sl-kicker{ color: rgba(255,255,255,0.75); }
        .sl-sectionDark .sl-sectionTitle{ color: #ffffff; }
        .sl-sectionDark .sl-sectionDesc{ color: rgba(203,213,225,0.92); }
        .sl-sectionDark .sl-badge{
          background: rgba(255,255,255,0.08);
          border: 1px solid rgba(255,255,255,0.12);
          color: #ffffff;
        }

        /* Feature cards */
        .sl-featureGrid{
          display:grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 12px;
        }
        .sl-featureCard{
          border-radius: 16px;
          padding: 16px;
          background: linear-gradient(180deg, rgba(255,255,255,0.95), rgba(248,250,252,0.90));
          border: 1px solid rgba(226,232,240,1);
          box-shadow: 0 12px 26px rgba(15,23,42,0.06);
          position: relative;
          overflow: hidden;
        }
        .sl-featureCard::after{
          content:"";
          position:absolute;
          inset:-120px auto auto -120px;
          width:220px; height:220px;
          background: radial-gradient(circle, rgba(37,99,235,0.14), transparent 62%);
          border-radius: 999px;
        }
        .sl-featureTop{
          display:flex;
          align-items:center;
          justify-content:space-between;
          gap:10px;
          margin-bottom: 10px;
          position: relative;
          z-index: 1;
        }
        .sl-featureIcon{
          width:38px; height:38px;
          border-radius:14px;
          display:flex;
          align-items:center;
          justify-content:center;
          background: linear-gradient(135deg, rgba(37,99,235,0.22), rgba(109,92,246,0.18));
          border: 1px solid rgba(37,99,235,0.18);
          font-size: 18px;
        }
        .sl-featureMeta{
          font-size: 12px;
          font-weight: 900;
          color: #1d4ed8;
          background: rgba(37,99,235,0.10);
          border: 1px solid rgba(37,99,235,0.18);
          padding: 6px 10px;
          border-radius: 999px;
        }
        .sl-featureTitle{
          margin: 0;
          color: #0f172a;
          font-size: 15px;
          position: relative;
          z-index: 1;
        }
        .sl-featureDesc{
          margin: 8px 0 0;
          color: #475569;
          line-height: 1.65;
          font-size: 14px;
          position: relative;
          z-index: 1;
        }

        /* Marquee */
        .sl-marqueeWrap{
          position: relative;
          border-radius: 18px;
          border: 1px solid rgba(226,232,240,1);
          background: linear-gradient(180deg, rgba(255,255,255,0.95), rgba(248,250,252,0.85));
          overflow: hidden;
          padding: 12px 0;
          box-shadow: 0 16px 40px rgba(15,23,42,0.06);
        }
        .sl-marqueeTrack{
          display:flex;
          gap: 14px;
          width: max-content;
          animation: slMarquee 26s linear infinite;
          padding: 6px 14px;
        }
        .sl-marqueeWrap:hover .sl-marqueeTrack{ animation-play-state: paused; }
        @keyframes slMarquee{ from { transform: translateX(0); } to { transform: translateX(-50%); } }
        .sl-marqueeItem{
          min-width: 170px;
          height: 80px;
          display:flex;
          align-items:center;
          justify-content:center;
          border-radius: 14px;
          border: 1px solid rgba(226,232,240,1);
          background: rgba(255,255,255,0.85);
          box-shadow: 0 10px 22px rgba(15,23,42,0.04);
        }
        .sl-marqueeItem img{
          max-width: 200px;
          max-height: 120px;
          object-fit: contain;
          filter: grayscale(12%);
          opacity: 0.95;
        }
        .sl-marqueeFade{
          position:absolute;
          top:0; bottom:0;
          width: 80px;
          z-index: 2;
          pointer-events:none;
        }
        .sl-marqueeFade.sl-left{
          left:0;
          background: linear-gradient(90deg, rgba(255,255,255,1), rgba(255,255,255,0));
        }
        .sl-marqueeFade.sl-right{
          right:0;
          background: linear-gradient(270deg, rgba(255,255,255,1), rgba(255,255,255,0));
        }

        /* Stats strip */
        .sl-statGrid {
          display: grid;
          grid-template-columns: repeat(4, minmax(0, 1fr));
          gap: 12px;
        }
        .sl-statItem {
          border-radius: 14px;
          border: 1px solid rgba(255,255,255,0.10);
          background: rgba(255,255,255,0.06);
          padding: 14px;
        }
        .sl-statValue {
          font-size: 28px;
          font-weight: 950;
          color: #ffffff;
          letter-spacing: -0.02em;
        }
        .sl-statLabel {
          margin-top: 6px;
          color: rgba(203,213,225,0.92);
          font-size: 13px;
          line-height: 1.4;
        }

        /* Comparison table */
        .sl-compareWrap {
          margin-top: 14px;
          border-radius: 18px;
          overflow: hidden;
          border: 1px solid rgba(219,230,251,0.95);
          background: rgba(255,255,255,0.92);
          box-shadow: 0 16px 40px rgba(15, 23, 42, 0.06);
        }
        .sl-compareHeader,
        .sl-compareRow { display: grid; grid-template-columns: 1.4fr 1fr 1fr; }
        .sl-compareHeader { background: linear-gradient(180deg, #0b1220, #0f172a); }
        .sl-compareCell {
          padding: 14px 14px;
          border-bottom: 1px solid rgba(226, 232, 240, 1);
          font-size: 14px;
        }
        .sl-compareHeader .sl-compareCell {
          border-bottom: 1px solid rgba(255,255,255,0.10);
          color: rgba(203,213,225,0.95);
          font-weight: 900;
        }
        .sl-compareHeadLeft { text-align: left; }
        .sl-compareHeadMid { text-align: center; }
        .sl-compareHeadRight { text-align: center; color: #ffffff; }
        .sl-compareLeft { color: #0f172a; font-weight: 900; }
        .sl-compareMid, .sl-compareRight { text-align: center; }
        .sl-compareTag {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 6px 10px;
          border-radius: 999px;
          font-weight: 900;
          font-size: 12px;
          border: 1px solid rgba(203,213,225,0.9);
          background: rgba(255,255,255,0.85);
          color: #0f172a;
          white-space: nowrap;
        }
        .sl-compareTag.good {
          border-color: rgba(16,185,129,0.25);
          background: rgba(16,185,129,0.10);
          color: #065f46;
        }
        .sl-compareTag.warn {
          border-color: rgba(245,158,11,0.28);
          background: rgba(245,158,11,0.10);
          color: #92400e;
        }
        .sl-compareTag.danger {
          border-color: rgba(239,68,68,0.25);
          background: rgba(239,68,68,0.08);
          color: #991b1b;
        }

        /* ChocoUp hero banner */
        .sl-chocoupHeroInner{
          border-radius: 18px;
          border: 2px solid rgba(109,92,246,0.22);
          background: linear-gradient(180deg, rgba(109,92,246,0.10), rgba(109,92,246,0.06));
          padding: 26px;
          display: grid;
          grid-template-columns: 1.2fr 0.8fr;
          gap: 18px;
          align-items: center;
          box-shadow: 0 18px 50px rgba(15, 23, 42, 0.08);
        }
        .sl-chocoupHeroTitle{
          margin: 0 0 10px;
          font-size: 46px;
          letter-spacing: -0.03em;
          line-height: 1.06;
          font-weight: 950;
          color: rgb(67, 56, 202);
        }
        .sl-chocoupHeroAccent{ color: rgb(109, 92, 246); }
        .sl-chocoupHeroDesc{
          margin: 0;
          color: rgba(67, 56, 202, 0.70);
          font-size: 16px;
          line-height: 1.7;
          max-width: 720px;
        }
        .sl-chocoupHeroRight{
          display: grid;
          justify-items: end;
          gap: 10px;
        }
        .sl-chocoupHeroBtn{
          border: none;
          border-radius: 14px;
          padding: 14px 16px;
          font-weight: 950;
          color: #ffffff;
          background: linear-gradient(135deg, rgb(109,92,246), rgb(67,56,202));
          box-shadow: 0 18px 40px rgba(109,92,246,0.22);
          cursor: pointer;
          min-width: 260px;
        }
        .sl-chocoupHeroNote{
          color: rgba(67, 56, 202, 0.65);
          font-size: 13px;
          font-weight: 800;
          display: inline-flex;
          align-items: center;
          gap: 8px;
        }

        /* ChocoUp benefits section */
        .sl-chocoupTopGrid{
          display: grid;
          grid-template-columns: repeat(4, minmax(0, 1fr));
          gap: 12px;
          margin-top: 14px;
          margin-bottom: 14px;
        }
        .sl-chocoupTopCard{
          border-radius: 16px;
          padding: 16px;
          border: 1px solid rgba(109,92,246,0.18);
          background: rgba(109,92,246,0.06);
          box-shadow: 0 12px 26px rgba(15,23,42,0.05);
        }
        .sl-chocoupTopValue{
          font-weight: 950;
          font-size: 28px;
          letter-spacing: -0.02em;
          color: rgb(67,56,202);
          margin-bottom: 6px;
        }
        .sl-chocoupTopLabel{
          color: rgba(15,23,42,0.65);
          font-size: 13px;
          line-height: 1.5;
          font-weight: 700;
        }

        .sl-chocoupTiles{
          display: grid;
          grid-template-columns: repeat(4, minmax(0, 1fr));
          gap: 12px;
        }
        .sl-chocoupTile{
          border-radius: 16px;
          padding: 16px;
          border: 1px solid rgba(226,232,240,1);
          background: rgba(255,255,255,0.85);
          box-shadow: 0 12px 26px rgba(15,23,42,0.05);
        }
        .sl-chocoupTile.tint{
          border: 1px solid rgba(109,92,246,0.22);
          background: rgba(109,92,246,0.06);
        }
        .sl-chocoupTileIcon{
          width: 38px;
          height: 38px;
          border-radius: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, rgba(109,92,246,0.20), rgba(37,99,235,0.12));
          border: 1px solid rgba(109,92,246,0.16);
          font-size: 18px;
          margin-bottom: 10px;
        }
        .sl-chocoupTileKicker{
          font-size: 11px;
          font-weight: 950;
          letter-spacing: .18em;
          color: rgba(100,116,139,0.9);
          margin-bottom: 8px;
        }
        .sl-chocoupTileTitle{
          font-weight: 950;
          color: #0f172a;
          margin-bottom: 6px;
        }
        .sl-chocoupTileDesc{
          color: rgba(71,85,105,0.95);
          line-height: 1.65;
          font-size: 13px;
        }

        .sl-chocoupBottomBar{
          margin-top: 14px;
          border-radius: 16px;
          border: 1px solid rgba(109,92,246,0.18);
          background: rgba(109,92,246,0.06);
          padding: 14px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          flex-wrap: wrap;
        }
        .sl-chocoupBottomLeft{
          display: flex;
          gap: 12px;
          align-items: center;
          flex-wrap: wrap;
        }
        .sl-chocoupBottomTag{
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 6px 10px;
          border-radius: 999px;
          font-weight: 950;
          font-size: 12px;
          color: rgb(15,23,42);
          background: rgba(250,204,21,0.35);
          border: 1px solid rgba(250,204,21,0.55);
        }
        .sl-chocoupBottomTitle{
          font-weight: 950;
          color: rgb(67,56,202);
          margin-bottom: 2px;
        }
        .sl-chocoupBottomDesc{
          color: rgba(67,56,202,0.65);
          font-weight: 700;
          font-size: 13px;
        }
        .sl-chocoupBottomRight{
          display: inline-flex;
          align-items: center;
          gap: 8px;
        }
        .sl-chocoupPill{
          display: inline-flex;
          align-items: center;
          gap: 10px;
          padding: 8px 12px;
          border-radius: 12px;
          border: 1px solid rgba(67,56,202,0.30);
          background: rgba(255,255,255,0.8);
          font-weight: 950;
          color: rgb(67,56,202);
        }
        .sl-chocoupPill.ghost{
          border: 1px solid rgba(109,92,246,0.30);
          color: rgb(109,92,246);
        }
        .sl-chocoupPillDot{
          width: 8px; height: 8px; border-radius: 999px;
          background: rgb(67,56,202);
          box-shadow: 0 0 0 4px rgba(67,56,202,0.08);
        }
        .sl-chocoupPillDot.alt{
          background: rgb(109,92,246);
          box-shadow: 0 0 0 4px rgba(109,92,246,0.10);
        }
        .sl-chocoupX{
          font-weight: 950;
          color: rgba(67,56,202,0.55);
          padding: 0 2px;
        }

        /* ChocoUp checklist inside form */
        .sl-checkWrap{
          border-radius: 16px;
          border: 1px solid rgba(109,92,246,0.22);
          background: rgba(109,92,246,0.06);
          overflow: hidden;
          margin-top: 14px;
        }
        .sl-checkHead{
          padding: 12px 14px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 10px;
          cursor: pointer;
          user-select: none;
        }
        .sl-checkHeadLeft{
          display: flex;
          align-items: center;
          gap: 10px;
          color: rgb(67,56,202);
          font-weight: 950;
          letter-spacing: .08em;
          text-transform: uppercase;
          font-size: 12px;
        }
        .sl-checkTick{
          width: 26px; height: 26px;
          border-radius: 999px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background: rgb(109,92,246);
          color: #fff;
          font-weight: 950;
          box-shadow: 0 12px 26px rgba(109,92,246,0.18);
        }
        .sl-checkCount{
          margin-left: 8px;
          padding: 6px 10px;
          border-radius: 999px;
          border: 1px solid rgba(109,92,246,0.24);
          background: rgba(255,255,255,0.7);
          color: rgb(67,56,202);
          font-weight: 950;
          font-size: 12px;
          letter-spacing: normal;
          text-transform: none;
        }
        .sl-checkChevron{
          color: rgba(67,56,202,0.75);
          font-weight: 950;
          font-size: 14px;
        }
        .sl-checkBody{
          padding: 12px 14px 14px;
          background: rgba(255,255,255,0.55);
          border-top: 1px solid rgba(109,92,246,0.12);
        }
        .sl-checkItem{
          display: grid;
          grid-template-columns: 22px 1fr;
          gap: 10px;
          align-items: start;
          padding: 10px 0;
          border-bottom: 1px solid rgba(226,232,240,0.8);
        }
        .sl-checkItem:last-child{ border-bottom: none; }
        .sl-checkLabel{
          color: rgba(15,23,42,0.72);
          font-weight: 700;
          line-height: 1.5;
          font-size: 13px;
        }

        .chocoupphoto{
          margin-left: 15px;
        }

        /* Mobile / responsive */
        @media (max-width: 980px) {
          .sl-layout { grid-template-columns: 1fr !important; }
          .sl-sticky { position: relative !important; top: auto !important; }
          .sl-hero-title { font-size: 36px !important; }
          .sl-grid3 { grid-template-columns: 1fr !important; }

          .sl-container { max-width: 95vw !important; }
          .sl-topbar {
            position: relative !important;
            top: auto !important;
            padding: 10px 12px !important;
            border-radius: 14px !important;
            backdrop-filter: none !important;
            -webkit-backdrop-filter: none !important;
          }
          .sl-topbar .sl-sectionRight { display: none !important; }
          .sl-topbar img { width: 170px !important; }

          .sl-featureGrid{ grid-template-columns: 1fr; }
          .sl-sectionHeader{ align-items:flex-start; }
          .sl-sectionRight{ justify-content:flex-start; }
          .sl-statGrid { grid-template-columns: 1fr 1fr; }

          .sl-compareHeader, .sl-compareRow { grid-template-columns: 1fr; }
          .sl-compareHeadMid, .sl-compareHeadRight { display: none; }
          .sl-compareMid, .sl-compareRight { text-align: left; padding-top: 0; }
          .sl-compareMid::before {
            content: "Loan Broker: ";
            font-weight: 900;
            color: #334155;
            margin-right: 6px;
          }
          .sl-compareRight::before {
            content: "SmartLend: ";
            font-weight: 900;
            color: #334155;
            margin-right: 6px;
          }

          /* Hide any mobile-disable blocks */
          section.mobile-disable,
          .mobile-disable { display: none !important; }

          /* ChocoUp hero + benefits responsive */
          .sl-chocoupHeroInner{ grid-template-columns: 1fr; }
          .sl-chocoupHeroRight{ justify-items: start; }
          .sl-chocoupHeroTitle{ font-size: 34px; }
          .sl-chocoupHeroBtn{ min-width: unset; width: 100%; }

          .sl-chocoupTopGrid{ grid-template-columns: 1fr 1fr; }
          .sl-chocoupTiles{ grid-template-columns: 1fr; }
          .sl-chocoupBottomRight{ width: 100%; justify-content: flex-start; }
        }

        /* Hide SectionHeader right side on mobile globally (keeps your current behavior) */
        @media (max-width: 980px) {
          .sl-sectionHeader .sl-sectionRight {
            display: none !important;
          }

          .chocoupphoto{
            margin-left: 0px;
          }
        }


        /* Bottom CTA */
        .sl-bottomCta{
          position: relative;
          overflow: hidden;
          border-radius: 24px;
          border: 1px solid rgba(109,92,246,0.16);
          background:
            radial-gradient(900px 320px at 10% 20%, rgba(37,99,235,0.18), transparent 60%),
            radial-gradient(800px 300px at 90% 20%, rgba(109,92,246,0.18), transparent 60%),
            linear-gradient(135deg, #0b1220 0%, #111827 55%, #1e1b4b 100%);
          box-shadow: 0 24px 60px rgba(2,6,23,0.28);
          padding: 28px;
        }

        .sl-bottomCtaInner{
          position: relative;
          z-index: 2;
          display: grid;
          grid-template-columns: 1.3fr 0.7fr;
          gap: 20px;
          align-items: center;
        }

        .sl-bottomCtaKicker{
          font-size: 12px;
          font-weight: 950;
          letter-spacing: .16em;
          text-transform: uppercase;
          color: rgba(191,219,254,0.95);
          margin-bottom: 10px;
        }

        .sl-bottomCtaTitle{
          margin: 0;
          font-size: 38px;
          line-height: 1.08;
          letter-spacing: -0.03em;
          color: #ffffff;
        }

        .sl-bottomCtaDesc{
          margin: 14px 0 0;
          color: rgba(226,232,240,0.92);
          font-size: 15px;
          line-height: 1.75;
          max-width: 760px;
        }

        .sl-bottomCtaBadges{
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 18px;
        }

        .sl-bottomCtaAction{
          display: grid;
          justify-items: end;
          gap: 12px;
        }

        .sl-bottomCtaBtn{
          border: none;
          border-radius: 14px;
          padding: 16px 22px;
          min-width: 260px;
          font-weight: 950;
          font-size: 15px;
          color: #ffffff;
          background: linear-gradient(135deg, #2563eb 0%, #6d5cf6 100%);
          box-shadow: 0 18px 40px rgba(37,99,235,0.30);
          cursor: pointer;
        }

        .sl-bottomCtaNote{
          color: rgba(191,219,254,0.88);
          font-size: 13px;
          font-weight: 800;
        }

        .sl-bottomCtaGlow{
          position: absolute;
          border-radius: 999px;
          pointer-events: none;
          filter: blur(10px);
          z-index: 1;
        }

        .sl-bottomCtaGlow1{
          width: 260px;
          height: 260px;
          top: -80px;
          left: -60px;
          background: rgba(37,99,235,0.22);
        }

        .sl-bottomCtaGlow2{
          width: 320px;
          height: 320px;
          right: -100px;
          bottom: -120px;
          background: rgba(109,92,246,0.18);
        }

        @media (max-width: 980px) {
          .sl-bottomCta{
            padding: 20px;
            border-radius: 18px;
          }

          .sl-bottomCtaInner{
            grid-template-columns: 1fr;
            gap: 16px;
          }

          .sl-bottomCtaTitle{
            font-size: 28px;
          }

          .sl-bottomCtaAction{
            justify-items: stretch;
          }

          .sl-bottomCtaBtn{
            width: 100%;
            min-width: unset;
          }

          .sl-bottomCtaNote{
            text-align: center;
          }
        }
      `}</style>

      <div className="sl-container" style={styles.container}>
        {/* Top bar */}
        <section className="sl-topbar" style={styles.topBar}>
          <div
            style={{
              ...styles.brandLeft,
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              src={smartLendLogo}
              alt="SmartLend logo"
              style={{
                width: 250,
                maxWidth: "100%",
                height: "auto",
                cursor: "pointer",
              }}
              onClick={() => {
                history.push("/home");
                window.scrollTo(0, 0);
              }}
            />
            {isChocoUpPartnership ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-end",
                  gap: "15px",
                  borderLeft: "3px solid rgba(82, 26, 159, 0.4)",
                  justifyContent: "flex-start",
                }}
              >
                <img
                  className="chocoupphoto"
                  src={chocoUpLogo}
                  alt="Choco Up"
                  style={{
                    height: 35,
                    width: "auto",
                    // marginLeft: "15px",
                    objectFit: "contain",
                  }}
                />
              </div>
            ) : null}
          </div>

          <div className="sl-sectionRight">
            <IconBadge icon="⚡" label="Fast eligibility checks" />
            <IconBadge icon="🤝" label="Lender matching" />
            <IconBadge icon="🔒" label="Singpass / Corppass" />
          </div>
        </section>

        {/* Hero */}
        <div style={styles.hero}>
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
            <p
              style={{
                background: "rgba(37,99,235,0.1)",
                padding: "5px 15px",
                borderRadius: "20px",
                color: "#2563eb",
                margin: 0,
              }}
            >
              🇸🇬 Singapore's P2P Corporate Loan Marketplace
            </p>

            {isChocoUpPartnership ? (
              <p
                style={{
                  background: "rgba(109,92,246,0.10)",
                  padding: "5px 12px",
                  borderRadius: "20px",
                  color: "rgb(67,56,202)",
                  margin: 0,
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                In partnership with{" "}
                <img
                  src={chocoUpLogo}
                  alt="Choco Up"
                  style={{ height: 16, width: "auto", objectFit: "contain" }}
                />
              </p>
            ) : null}
          </div>

          <h1
            className="sl-hero-title"
            style={{ ...styles.heroTitle, marginTop: "10px" }}
            id="hero-text"
          >
            <span style={{ fontWeight: 900, color: "rgb(40,40,40)" }}>
              One Application.{" "}
            </span>
            <span style={{ fontWeight: 900, color: "#1d4ed8" }}>
              Every Lender.
            </span>
            <span style={{ fontWeight: 900, color: "rgb(40,40,40)" }}>
              {" "}
              Zero Broker Fees.
            </span>
          </h1>

          <p style={styles.heroDesc}>
            Adjust loan amount, tenure and indicative rate for a quick estimate.
            Share your contact details and our team will reach out with
            financing options that fit your business cash-flow and goals.
          </p>

          <div style={{ display: "flex", marginTop: "20px" }}>
            <div
              style={{
                border: "1px solid rgba(32, 121, 72, 1)",
                color: "rgba(32, 121, 72, 1)",
                background: "rgba(67, 183, 119, 0.1)",
                padding: "8px 15px",
                borderRadius: "15px",
                fontSize: "13px",
              }}
            >
              🚫 No broker. No middleman. No hidden fees. Completely free for
              borrowers
            </div>
          </div>
        </div>

        {/* Main */}
        <div className="sl-layout" style={styles.layout} id="sl-form">
          {/* Left */}
          <section style={styles.card} className="sl-fade">
            <div style={styles.cardGlow} />

            <div style={styles.stepper}>
              <div style={styles.stepPill(step === 1)}>
                <span style={styles.stepBubble(step === 1)}>1</span>
                Setup estimate
              </div>
              <div style={styles.stepPill(step === 2)}>
                <span style={styles.stepBubble(step === 2)}>2</span>
                Contact details
              </div>
            </div>

            <h2 style={styles.sectionTitle}>
              {step === 1 ? "Setup your estimate" : "Your contact details"}
            </h2>

            <p style={styles.muted}>
              {step === 1
                ? isChocoUpPartnership
                  ? "Complete the quick pre-qualification inputs below, then continue to share your contact details."
                  : "Use the sliders to model different scenarios."
                : "We’ll use this to contact you about suitable financing options."}
            </p>

            {step === 1 ? (
              <>
                <label style={styles.fieldLabel}>Loan amount</label>
                <div style={styles.rangeRow}>
                  <input
                    className="sl-range"
                    type="range"
                    min="10000"
                    max="500000"
                    step="5000"
                    value={loanAmount}
                    onChange={(e) => setLoanAmount(Number(e.target.value))}
                  />
                  <div style={styles.rangeValue}>
                    {formatCurrency(loanAmount)}
                  </div>
                </div>

                <label style={styles.fieldLabel}>Loan term</label>
                <div style={{ position: "relative", marginBottom: 14 }}>
                  <select
                    value={loanTerm}
                    onChange={(e) => setLoanTerm(Number(e.target.value))}
                    style={styles.select}
                    aria-label="Loan term in months"
                  >
                    <option value={6}>6 months</option>
                    <option value={9}>9 months</option>
                    <option value={12}>12 months</option>
                    {/* <option value={18}>18 months</option> */}
                  </select>
                </div>

                <label style={styles.fieldLabel}>
                  Indicative interest rate{" "}
                  <span style={{ color: "#1d4ed8", fontWeight: 950 }}>
                    ({effectiveMonthlyRate.toFixed(1)}% p.m.)
                  </span>
                </label>
                <div style={styles.rangeRow}>
                  <input
                    className="sl-range"
                    type="range"
                    min="1.5"
                    max="5"
                    step="0.1"
                    value={effectiveMonthlyRate}
                    disabled={isChocoUpPartnership}
                    onChange={(e) => setMonthlyRate(Number(e.target.value))}
                  />
                  <div style={styles.rangeValue}>
                    {effectiveMonthlyRate.toFixed(1)}%
                  </div>
                </div>

                {/* ChocoUp ONLY: extra inputs + checklist (from screenshot) */}
                {isChocoUpPartnership ? (
                  <>
                    <div style={{ marginTop: 14, display: "grid", gap: 12 }}>
                      <div>
                        <label style={styles.fieldLabel}>
                          Average monthly revenue{" "}
                          <span style={{ color: "#64748b" }}>(SGD)</span>
                        </label>
                        <input
                          type="text"
                          inputMode="numeric"
                          value={avgMonthlyRevenue}
                          onChange={(e) => {
                            // allow digits + commas only
                            const next = e.target.value.replace(/[^\d,]/g, "");
                            setAvgMonthlyRevenue(next);
                          }}
                          placeholder="e.g. 30,000"
                          style={styles.input}
                        />
                      </div>

                      <div>
                        <label style={styles.fieldLabel}>
                          How long has your business been operating?
                        </label>
                        <select
                          value={businessOperating}
                          onChange={(e) => setBusinessOperating(e.target.value)}
                          style={styles.select}
                          aria-label="Business operating duration"
                        >
                          <option>Less than 6 months</option>
                          <option>6 to 12 months</option>
                          <option>1 to 3 years</option>
                          <option>More than 3 years</option>
                        </select>
                      </div>

                      <div>
                        <label style={styles.fieldLabel}>
                          Do you currently have existing financing?
                        </label>
                        <select
                          value={hasExistingFinancing}
                          onChange={(e) =>
                            setHasExistingFinancing(e.target.value)
                          }
                          style={styles.select}
                          aria-label="Existing financing"
                        >
                          <option>No</option>
                          <option>Yes</option>
                        </select>
                      </div>
                    </div>

                    <div className="sl-checkWrap">
                      <div
                        className="sl-checkHead"
                        role="button"
                        tabIndex={0}
                        onClick={() => setChecklistOpen((v) => !v)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            setChecklistOpen((v) => !v);
                          }
                        }}
                        aria-expanded={checklistOpen ? "true" : "false"}
                      >
                        <div className="sl-checkHeadLeft">
                          <span className="sl-checkTick">✓</span>
                          <span>PRE-QUALIFICATION CHECKLIST</span>
                          <span className="sl-checkCount">
                            {checkedCount}/{CHOCOUP_CHECKLIST.length}
                          </span>
                        </div>
                        <div className="sl-checkChevron">
                          {checklistOpen ? "▲" : "▼"}
                        </div>
                      </div>

                      {checklistOpen ? (
                        <div className="sl-checkBody">
                          {CHOCOUP_CHECKLIST.map((it) => (
                            <label className="sl-checkItem" key={it.key}>
                              <input
                                type="checkbox"
                                checked={!!prequal?.[it.key]}
                                onChange={(e) => {
                                  const next = e.target.checked;
                                  setPrequal((p) => ({ ...p, [it.key]: next }));
                                }}
                                style={{ marginTop: 3 }}
                              />
                              <span className="sl-checkLabel">{it.label}</span>
                            </label>
                          ))}
                        </div>
                      ) : null}
                    </div>

                    {prequalFeedbackMessage ? (
                      <div
                        style={{
                          marginTop: 12,
                          borderRadius: 12,
                          border: `1px solid ${
                            checkedCount === CHOCOUP_CHECKLIST.length
                              ? "rgba(22,163,74,0.35)"
                              : "rgba(245,158,11,0.35)"
                          }`,
                          background:
                            checkedCount === CHOCOUP_CHECKLIST.length
                              ? "rgba(22,163,74,0.08)"
                              : "rgba(245,158,11,0.10)",
                          color:
                            checkedCount === CHOCOUP_CHECKLIST.length
                              ? "#14532d"
                              : "#92400e",
                          padding: "12px 14px",
                          fontSize: 13,
                          lineHeight: 1.5,
                          whiteSpace: "pre-line",
                          fontWeight: 600,
                        }}
                      >
                        {prequalFeedbackMessage}
                      </div>
                    ) : null}

                    <div
                      style={{
                        marginTop: 12,
                        color: "#64748b",
                        fontSize: 12,
                        lineHeight: 1.5,
                      }}
                    >
                      Tip: Indicative only — actual offers depend on Choco Up’s
                      assessment.
                    </div>
                  </>
                ) : null}

                <div style={{ display: "grid", gap: 10, marginTop: 14 }}>
                  <button
                    type="button"
                    onClick={() => {
                      setStep(2);
                      saveLeadSnapshot({
                        lead_data: {
                          step: 2,
                          event: isChocoUpPartnership
                            ? "chocoup_continue_to_contact"
                            : "continue_to_contact",
                        },
                      });
                    }}
                    style={styles.btnPrimary(true)}
                  >
                    Check My Eligibility →
                  </button>

                  {!isChocoUpPartnership ? (
                    <p
                      style={{
                        margin: 0,
                        color: "#64748b",
                        fontSize: 12,
                        lineHeight: 1.5,
                      }}
                    >
                      Tip: Keep the rate “indicative” — actual offers depend on
                      lender assessment.
                    </p>
                  ) : null}
                </div>
              </>
            ) : (
              <>
                <label style={styles.fieldLabel}>Name</label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  onBlur={() => saveLeadSnapshot({ name })}
                  placeholder="e.g. Jane Tan"
                  style={{ ...styles.input, marginBottom: 12 }}
                />

                <label style={styles.fieldLabel}>Phone number</label>
                <input
                  type="tel"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  onBlur={() => saveLeadSnapshot({ phone_number: phone })}
                  placeholder="e.g. +65 9123 4567"
                  style={{ ...styles.input, marginBottom: 12 }}
                />

                <label
                  style={{ display: "flex", gap: 10, alignItems: "flex-start" }}
                >
                  <input
                    type="checkbox"
                    checked={consent}
                    onChange={(e) => setConsent(e.target.checked)}
                    style={{ marginTop: 3 }}
                  />
                  <span
                    style={{ color: "#475569", fontSize: 13, lineHeight: 1.55 }}
                  >
                    I agree to share my contact information with SmartLend so
                    the team can reach out and assist me with suitable financing
                    options and financial decision-making.
                  </span>
                </label>

                {touched && !formIsValid ? (
                  <p
                    style={{
                      color: "#b91c1c",
                      marginTop: 10,
                      marginBottom: 0,
                      fontWeight: 700,
                    }}
                  >
                    Please enter a valid name, phone number, and consent.
                  </p>
                ) : null}

                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1.5fr",
                    gap: 10,
                    marginTop: 14,
                  }}
                >
                  <button
                    type="button"
                    onClick={() => {
                      setStep(1);
                      setContactSubmitted(false);
                      saveLeadSnapshot({
                        lead_data: {
                          step: 1,
                          contact_submitted: false,
                          event: "back_to_estimate",
                        },
                      });
                    }}
                    style={styles.btnGhost}
                  >
                    Back
                  </button>

                  <button
                    type="button"
                    onClick={() => {
                      setTouched(true);

                      if (formIsValid) {
                        setContactSubmitted(true);
                        saveLeadSnapshot({
                          name,
                          phone_number: phone,
                          lead_data: {
                            touched: true,
                            contact_submitted: true,
                            consent,
                            event: isChocoUpPartnership
                              ? "chocoup_view_estimate"
                              : "view_estimate",
                          },
                        });
                        return;
                      }

                      saveLeadSnapshot({
                        lead_data: {
                          touched: true,
                          contact_submitted: false,
                          consent,
                          event: "invalid_submit_attempt",
                        },
                      });
                    }}
                    style={styles.btnPrimary(formIsValid)}
                    disabled={!formIsValid}
                  >
                    View estimate
                  </button>
                </div>

                {contactSubmitted ? (
                  <div
                    style={{
                      marginTop: 12,
                      padding: 12,
                      borderRadius: 14,
                      border: "1px solid rgba(16,185,129,0.25)",
                      background: "rgba(16,185,129,0.08)",
                    }}
                  >
                    <p style={{ margin: 0, color: "#065f46", fontWeight: 900 }}>
                      Details saved — estimate unlocked.
                    </p>
                    <p
                      style={{
                        margin: "6px 0 0",
                        color: "#065f46",
                        fontSize: 13,
                      }}
                    >
                      Our team may contact you to discuss the best route and
                      lenders.
                    </p>
                  </div>
                ) : null}
              </>
            )}
          </section>

          {/* Right */}
          <div>
            <section
              className="sl-sticky sl-fade"
              style={{ ...styles.rightCard }}
            >
              <div style={styles.rightGlow} />
              <h2 style={{ marginTop: 0, marginBottom: 10 }}>
                Your estimated repayment
              </h2>

              <div style={styles.estimateBox}>
                <p style={styles.estimateSub}>Estimated monthly repayment</p>
                <p style={styles.estimateBig}>{monthlyLabel}</p>
                <p
                  style={{
                    margin: "8px 0 0",
                    color: "#cbd5e1",
                    fontSize: 12,
                    lineHeight: 1.5,
                  }}
                >
                  Based on {formatCurrency(loanAmount)} over {loanTerm} months
                  at {effectiveMonthlyRate.toFixed(1)}% p.m.
                </p>
              </div>

              <p style={styles.miniRow}>
                Principal:{" "}
                <strong style={{ color: "#ffffff" }}>
                  {formatCurrency(loanAmount)}
                </strong>
              </p>
              <p style={styles.miniRow}>
                Total repayment:{" "}
                <strong style={{ color: "#ffffff" }}>
                  {formatCurrency(totalRepayment)}
                </strong>
              </p>
              <p style={styles.miniRow}>
                Total interest:{" "}
                <strong style={{ color: "#ffffff" }}>
                  {formatCurrency(totalInterest)}
                </strong>
              </p>

              <p style={styles.disclaimer}>
                Disclaimer: This is an indicative estimate for planning purposes
                only and is not a loan offer, approval decision, or guaranteed
                rate.
              </p>
            </section>

            <div
              style={{
                fontSize: "14px",
                marginTop: "20px",
                color: "rgb(70,70,70)",
              }}
            >
              <div>
                🔐 Less than 3 mins to apply - No impact on credit score.
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "15px",
                  marginTop: "10px",
                  flexWrap: "wrap",
                }}
              >
                <div style={{ fontWeight: 700 }}>Now enabled by:</div>
                <div
                  style={{
                    padding: "5px 12px",
                    border: "1px solid lightgrey",
                    borderRadius: "12px",
                  }}
                >
                  <img
                    src={enim1}
                    alt="Enabled by 1"
                    style={{ width: "80px" }}
                  />
                </div>
                <div
                  style={{
                    padding: "5px 12px",
                    border: "1px solid lightgrey",
                    borderRadius: "12px",
                  }}
                >
                  <img
                    src={enim2}
                    alt="Enabled by 2"
                    style={{ width: "80px" }}
                  />
                </div>
                <div
                  style={{
                    padding: "5px 12px",
                    border: "1px solid lightgrey",
                    borderRadius: "12px",
                  }}
                >
                  <img
                    src={enim3}
                    alt="Enabled by 3"
                    style={{ width: "80px" }}
                  />
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  gap: "20px",
                  marginTop: "15px",
                  marginBottom: "15px",
                  flexWrap: "wrap",
                }}
              >
                <div
                  style={{
                    padding: "5px 15px",
                    borderRadius: "20px",
                    background: "rgba(114, 96, 247, 0.1)",
                    border: "1px solid rgba(67, 67, 178, 1)",
                    color: "rgba(18, 0, 158, 1)",
                  }}
                >
                  ● Offers within 24-48 hours
                </div>
                <div
                  style={{
                    padding: "5px 15px",
                    borderRadius: "20px",
                    background: "rgba(114, 96, 247, 0.1)",
                    border: "1px solid rgba(67, 67, 178, 1)",
                    color: "rgba(18, 0, 158, 1)",
                  }}
                >
                  ● 20+ P2P Lenders
                </div>
                <div
                  style={{
                    padding: "5px 15px",
                    borderRadius: "20px",
                    background: "rgba(96, 247, 157, 0.1)",
                    border: "1px solid rgba(67, 178, 139, 1)",
                    color: "rgba(0, 158, 87, 1)",
                  }}
                >
                  ● Free CBS Report Included
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ChocoUp ONLY: benefits section from screenshot */}
        {renderChocoUpBenefitsSection()}

        <StatStrip items={STAT_ITEMS} />

        {/* ===== (1) OUR EDGE ===== */}
        <section className="sl-fade" style={{ marginTop: 18 }}>
          <div className="sl-sectionTint">
            <SectionHeader
              kicker="Our edge"
              title="Built for Singapore SMEs"
              desc="SmartLend isn't just a comparison tool. It's a full marketplace where lenders compete to win your business."
              right={
                <>
                  <IconBadge icon="🏦" label="20+ lenders" />
                  <IconBadge icon="🚫" label="Zero borrower fees" />
                  <IconBadge icon="⚡" label="Faster offers" />
                </>
              }
            />

            <div className="sl-featureGrid">
              {EDGE_FEATURES.map((f) => (
                <FeatureCard
                  key={f.title}
                  icon={f.icon}
                  title={f.title}
                  desc={f.desc}
                />
              ))}
            </div>
          </div>
        </section>

        {/* ===== (2) WHY SMARTLEND (comparison table) ===== */}
        <section className="mobile-disable sl-fade" style={{ marginTop: 18 }}>
          <div className="sl-sectionTint">
            <SectionHeader
              kicker="Why SmartLend"
              title="Stop paying broker fees. Start borrowing smarter."
              desc="Loan brokers typically charge 3%–8% of your loan amount — and in some cases, we've heard fees reaching 20%–30%. With SmartLend, that money stays in your pocket."
              right={
                <>
                  <IconBadge icon="✅" label="Compare offers" />
                  <IconBadge icon="🔎" label="Transparent" />
                  <IconBadge icon="🧾" label="Less back-and-forth" />
                </>
              }
            />
            <ComparisonTable rows={WHY_ROWS} />
          </div>
        </section>

        {/* ===== (4) WHO CAN APPLY ===== */}
        <section className="sl-fade" style={{ marginTop: 18 }}>
          <div className="sl-sectionTint">
            <SectionHeader
              kicker="Who can apply"
              title="Does your company qualify?"
              desc="P2P corporate loans are available to Singapore-registered Pte. Ltd. companies. Check your eligibility in seconds."
              right={
                <>
                  <IconBadge icon="🏢" label="Pte. Ltd." />
                  <IconBadge icon="📅" label="6+ months" />
                  <IconBadge icon="🇸🇬" label="Singapore-based" />
                </>
              }
            />

            <div className="sl-featureGrid">
              {QUALIFY_CARDS.map((c) => (
                <FeatureCard
                  key={c.title}
                  icon={c.icon}
                  title={c.title}
                  desc={c.desc}
                  meta={c.meta}
                />
              ))}
            </div>
          </div>
        </section>

        {/* Singpass / Corppass */}
        <section className="sl-sectionTint sl-fade" style={{ marginTop: 18 }}>
          <SectionHeader
            kicker="How it Works"
            title="3 steps. Under 3 minutes."
            desc="Thanks to our Singpass and CBS integration, we've eliminated the paperwork so lenders can assess your case at the fastest possible time."
            right={
              <div className="sl-singpassBadges">
                <IconBadge icon="🧾" label="Less paperwork" />
                <IconBadge icon="✅" label="Cleaner submissions" />
                <IconBadge icon="⏱️" label="Faster onboarding" />
              </div>
            }
          />

          <div
            className="sl-singpassGrid"
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 14,
              alignItems: "start",
            }}
          >
            <div>
              <img
                src={singpassLogo}
                alt="Singpass logo"
                style={{
                  width: 200,
                  maxWidth: "100%",
                  height: "auto",
                  marginBottom: 10,
                }}
              />

              <p style={{ margin: 0, color: "#475569", lineHeight: 1.7 }}>
                Use Singpass/Corppass to bring in verified business details so
                you spend less time on forms and more time choosing the best
                financing structure.
              </p>

              <div
                className="sl-steps"
                style={{ marginTop: 14, display: "grid", gap: 10 }}
              >
                <div
                  className="sl-step"
                  style={{
                    borderRadius: 14,
                    padding: 14,
                    border: "1px solid rgba(226,232,240,1)",
                    background: "rgba(255,255,255,0.75)",
                    boxShadow: "0 10px 22px rgba(15,23,42,0.05)",
                  }}
                >
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "32px 1fr",
                      gap: 10,
                    }}
                  >
                    <div
                      style={{
                        width: 26,
                        height: 26,
                        borderRadius: 10,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: 950,
                        color: "#fff",
                        background: "linear-gradient(135deg, #2563eb, #6d5cf6)",
                      }}
                    >
                      1
                    </div>
                    <div>
                      <div
                        style={{
                          fontWeight: 950,
                          color: "#0f172a",
                          marginBottom: 6,
                        }}
                      >
                        Log in via Singpass
                      </div>
                      <p
                        style={{
                          margin: 0,
                          color: "#475569",
                          lineHeight: 1.65,
                          fontSize: 13,
                        }}
                      >
                        Your personal and business details are auto-filled
                        instantly. No forms, no manual data entry — your info is
                        pulled directly and securely.
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  className="sl-step"
                  style={{
                    borderRadius: 14,
                    padding: 14,
                    border: "1px solid rgba(226,232,240,1)",
                    background: "rgba(255,255,255,0.75)",
                    boxShadow: "0 10px 22px rgba(15,23,42,0.05)",
                  }}
                >
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "32px 1fr",
                      gap: 10,
                    }}
                  >
                    <div
                      style={{
                        width: 26,
                        height: 26,
                        borderRadius: 10,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: 950,
                        color: "#fff",
                        background: "linear-gradient(135deg, #2563eb, #6d5cf6)",
                      }}
                    >
                      2
                    </div>
                    <div>
                      <div
                        style={{
                          fontWeight: 950,
                          color: "#0f172a",
                          marginBottom: 6,
                        }}
                      >
                        Upload bank statements + free CBS report
                      </div>
                      <p
                        style={{
                          margin: 0,
                          color: "#475569",
                          lineHeight: 1.65,
                          fontSize: 13,
                        }}
                      >
                        Upload your last 6 months of bank statements. We'll give
                        you a free CBS access code to retrieve your credit
                        report — at no cost to you.
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  className="sl-step"
                  style={{
                    borderRadius: 14,
                    padding: 14,
                    border: "1px solid rgba(226,232,240,1)",
                    background: "rgba(255,255,255,0.75)",
                    boxShadow: "0 10px 22px rgba(15,23,42,0.05)",
                  }}
                >
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "32px 1fr",
                      gap: 10,
                    }}
                  >
                    <div
                      style={{
                        width: 26,
                        height: 26,
                        borderRadius: 10,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: 950,
                        color: "#fff",
                        background: "linear-gradient(135deg, #2563eb, #6d5cf6)",
                      }}
                    >
                      3
                    </div>
                    <div>
                      <div
                        style={{
                          fontWeight: 950,
                          color: "#0f172a",
                          marginBottom: 6,
                        }}
                      >
                        Receive & compare competing offers
                      </div>
                      <p
                        style={{
                          margin: 0,
                          color: "#475569",
                          lineHeight: 1.65,
                          fontSize: 13,
                        }}
                      >
                        Lenders compete for your business. You receive multiple
                        offers within 24–48 hours, compare them side by side,
                        and choose entirely on your own terms.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="sl-singpassFeatures">
              <div
                className="sl-featureGrid"
                style={{ gridTemplateColumns: "1fr" }}
              >
                <FeatureCard
                  icon="🛡️"
                  title="Secure by design"
                  desc="We minimise data handling while improving consistency for your application."
                  meta="Trusted flow"
                />
                <FeatureCard
                  icon="📌"
                  title="Less back-and-forth"
                  desc="Cleaner submissions reduce follow-ups and missing-information delays."
                  meta="Fewer revisions"
                />
                <FeatureCard
                  icon="🚀"
                  title="Speed to options"
                  desc="Once the basics are in, we focus on matching lenders and structures."
                  meta="Faster response"
                />
              </div>
            </div>
          </div>
        </section>

        {/* ChocoUp hero banner (ONLY when partnership=chocoup) */}
        {renderChocoUpHeroBanner()}

        {/* Benefits (your original) */}
        <section className="sl-fade" style={{ marginTop: 18 }}>
          <div className="sl-sectionTint">
            <SectionHeader
              kicker="Benefits"
              title="Why businesses choose SmartLend"
              desc="A financing journey that feels guided — not confusing. We focus on clarity, speed, and practical outcomes."
              right={
                <>
                  <IconBadge icon="📈" label="Cash-flow friendly" />
                  <IconBadge icon="🧠" label="Real advisory" />
                  <IconBadge icon="🧩" label="Multiple options" />
                </>
              }
            />

            <div className="sl-featureGrid">
              <FeatureCard
                icon="🏦"
                meta="Choice"
                title="Access to a pool of lenders"
                desc="Compare multiple partner options in one place so you can pick what fits your business best."
              />
              <FeatureCard
                icon="🧑‍💼"
                meta="Guided"
                title="Dedicated support team"
                desc="We support you through preparation, lender matching, and follow-ups — with clear next steps."
              />
              <FeatureCard
                icon="🧾"
                meta="Tailored"
                title="Tailored business financing"
                desc="Advice based on your profile, repayment horizon, and operational cash-flow needs."
              />
            </div>
          </div>
        </section>

        {/* Promise */}
        <section className="sl-sectionDark sl-fade" style={{ marginTop: 18 }}>
          <SectionHeader
            kicker="Our promise"
            title="Speed — with real advisory"
            desc="We don’t just pass your form around. We help you understand the trade-offs and choose a practical route."
            right={
              <>
                <IconBadge icon="🧭" label="Clear direction" />
                <IconBadge icon="🧪" label="Practical routes" />
                <IconBadge icon="📣" label="Transparent updates" />
              </>
            }
          />

          <div className="sl-featureGrid">
            <FeatureCard
              icon="⚡"
              meta="Fast"
              title="Fast, guided financing journey"
              desc="Quick steps, clear checkpoints, and updates so you always know what’s happening."
            />
            <FeatureCard
              icon="🧱"
              meta="Resilient"
              title="Support for challenging profiles"
              desc="Even if financials aren’t perfect, we explore structures and realistic options."
            />
            <FeatureCard
              icon="🔁"
              meta="No dead-ends"
              title="No business left hanging"
              desc="If one option doesn’t fit, we guide you to the next best route with clarity."
            />
          </div>

          <div
            style={{
              marginTop: 14,
              display: "flex",
              gap: 10,
              flexWrap: "wrap",
            }}
          >
            <span className="sl-badge">
              <span className="sl-badgeIcon">🧾</span> Better packaging
            </span>
            <span className="sl-badge">
              <span className="sl-badgeIcon">📌</span> Clear requirements
            </span>
            <span className="sl-badge">
              <span className="sl-badgeIcon">🤝</span> Human support
            </span>
          </div>
        </section>

        {/* Featured */}
        <section className="sl-fade" style={{ marginTop: 18 }}>
          <SectionHeader
            kicker="Coverage"
            title="As featured on"
            desc="A few places where SmartLend and SME financing innovation have been discussed."
            right={
              <>
                <IconBadge icon="✨" label="Trusted by SMEs" />
                <IconBadge icon="🗞️" label="Media coverage" />
              </>
            }
            align="left"
          />

          <MarqueeLogos logos={featuredLogos} />

          <p
            style={{
              marginTop: 10,
              marginBottom: 0,
              color: "#64748b",
              fontSize: 12,
              lineHeight: 1.6,
            }}
          >
            Note: Logos shown are for recognition only and do not imply
            endorsement.
          </p>
        </section>

        <FaqSection />
        {/* Bottom CTA */}
        <section className="sl-bottomCta sl-fade" style={{ marginTop: 18 }}>
          <div className="sl-bottomCtaGlow sl-bottomCtaGlow1" />
          <div className="sl-bottomCtaGlow sl-bottomCtaGlow2" />

          <div className="sl-bottomCtaInner">
            <div className="sl-bottomCtaContent">
              <div className="sl-bottomCtaKicker">
                Ready to explore your options?
              </div>
              <h2 className="sl-bottomCtaTitle">
                Get matched with suitable lenders in minutes — not days.
              </h2>
              <p className="sl-bottomCtaDesc">
                Start with a quick eligibility check, get a clearer view of your
                financing options, and let SmartLend guide you toward the most
                practical route for your business.
              </p>

              <div className="sl-bottomCtaBadges">
                <span className="sl-badge">
                  <span className="sl-badgeIcon">⚡</span> Fast eligibility
                  check
                </span>
                <span className="sl-badge">
                  <span className="sl-badgeIcon">🏦</span> Multiple lender
                  options
                </span>
                <span className="sl-badge">
                  <span className="sl-badgeIcon">🚫</span> Zero broker fees
                </span>
              </div>
            </div>

            <div className="sl-bottomCtaAction">
              <button
                type="button"
                className="sl-bottomCtaBtn"
                onClick={() => {
                  const el = document.getElementById("hero-text");
                  if (el) {
                    el.scrollIntoView({ behavior: "smooth", block: "start" });
                  }
                }}
              >
                Check My Eligibility
              </button>

              <div className="sl-bottomCtaNote">
                Takes less than 3 minutes to get started
              </div>
            </div>
          </div>
        </section>

        <div style={{ height: 18 }} />
      </div>
    </div>
  );
};

export default CorporateCampaign;
